  <template>
    <v-app-bar id="nav" app dense>
      <v-app-bar-nav-icon @click.stop="$emit('drawer')" style="color:#1d4ed8"></v-app-bar-nav-icon>
      
      <!-- Nome da página atual -->
      <v-toolbar-title class="ml-2" style="color:#1d4ed8; font-size: 0.95rem;">
        {{ pageTitle }}
      </v-toolbar-title>
      
      <v-spacer></v-spacer>
      
      <!-- Informações do usuário -->
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div 
            style="display: flex; flex-direction: row; align-items: center; color:#1d4ed8; cursor: pointer;"
            v-bind="attrs"
            v-on="on"
          >
            <v-avatar color="#1d4ed8" size="40" style="margin-right: 8px; flex-shrink: 0;">
              <span style="color: white; font-weight: bold; font-size: 0.85rem;">{{ userInitials }}</span>
            </v-avatar>
            <div style="display: flex; flex-direction: column; line-height: 1.2;">
              <span style="font-size: 0.85rem; font-weight: 600;">{{ userData.username }}</span>
              <div style="display: flex; align-items: center;">
                <span style="font-size: 0.75rem; opacity: 0.8; margin-right: 8px;">{{ userData.description }}</span>
                <span style="font-size: 0.8rem;">
                  <span v-if="timeRemaining > 300" style="color: #1d4ed8;">{{ formattedTime }}</span>
                  <span v-else-if="timeRemaining > 0" style="color: #F59E0B; font-weight: bold;">{{ formattedTime }}</span>
                  <span v-else style="font-size: 0.7rem; color: #DC2626;">Expirado</span>
                </span>
              </div>
            </div>
          </div>
        </template>
        <v-list>
          <v-list-item @click="showLogoutDialog = true">
            <v-list-item-icon>
              <v-icon color="#1d4ed8">mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Sair</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- Modal de Confirmação de Logout -->
      <v-dialog v-model="showLogoutDialog" max-width="400">
        <v-card>
          <v-card-title class="text-h6" style="color:#1d4ed8;">
            Sair do Sistema
          </v-card-title>
          <v-card-text>
            Tem certeza que deseja sair do sistema?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="showLogoutDialog = false">
              Cancelar
            </v-btn>
            <v-btn color="#1d4ed8" dark @click="confirmLogout">
              Sair
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app-bar>
  </template>  <script>
  import axios from 'axios'
  import { estadoSessao, encerrarSessao } from '../../plugins/sessao'

  export default {
    name: 'Header',
    data() {
      return {
        userData: {
          id: null,
          description: '',
          username: ''
        },
        showLogoutDialog: false
      };
    },
    computed: {
      //
      // O contador do cabecalho passa a mostrar quanto falta para o logout por
      // INATIVIDADE, nao a validade do token. E o numero que interessa ao
      // usuario agora: enquanto ele estiver usando o portal, o token se renova
      // sozinho e a validade dele nao e informacao acionavel.
      //
      // Vem do estado observavel do plugins/sessao, calculado por timestamp
      // absoluto. O contador antigo era local e decrementava 1 por tick de
      // setInterval - em aba oculta, que o navegador estrangula, ele atrasava
      // em relacao ao relogio e mostrava tempo que nao existia.
      //
      timeRemaining() {
        return Math.max(0, Math.floor(estadoSessao.restanteOciosidadeMs / 1000));
      },
      // Converte o tempo restante para o formato mm:ss
      formattedTime() {
        const minutes = Math.floor(this.timeRemaining / 60);
        const seconds = this.timeRemaining % 60;
        return `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
      },
      pageTitle() {
        const routeNames = {
          'CTE': 'Painel CT-e',
          'MDFE': 'Painel MDF-e',
          'Exportar': 'Exportar Dados',
          'Xlsx': 'Exportar CSV',
          'Receber': 'Contas a Receber',
          'Monitor': 'Painel Inicial',
          'MDFEE': 'Encerramento MDF-e',
          'Tranportador': 'Cadastro de Transportador',
          'TranportadorNovo': 'Cadastro de Transportador (novo)',
          'TransportadorDetalhe': 'Transportador',
          'TransportadorCadastrar': 'Novo Transportador',
          'HabilitarIntegracaoCiot': 'Habilitar Integração CIOT',
          'CancelarCte': 'Cancelar CT-e',
          'AverbacaoCteLote': 'Averbação CT-e em Lote',
          'LogCadastros': 'Log de Cadastros',
          'AtualizaCertificado': 'Atualizar Certificado',
          'EmissaoViagem': 'Emissão de Viagem',
          'RelatorioProdutividade': 'Relatório de Produtividade',
          'Contratos': 'Geração de Contratos',
          'Rotina-adm': 'Rotinas Administrativas',
          'RelatorioViagens': 'Relatório de Viagens',
          'Tributacao': 'Tributação',
          'TributacaoNova': 'Tributação (nova)',
          'NfseConfiguracao': 'Configuração de NFS-e',
          'CertificadosDigitais': 'Certificados Digitais',
          'Faturas': 'Faturas',
          'ControleContratos': 'Controle de Contratos',
          'EmConstrucao': 'Funcionalidade em Construção',
          'ListaMotoristas': 'Motoristas',
          'NovoMotorista': 'Novo Motorista',
          'EditarMotorista': 'Editar Motorista',
          'VisualizarMotorista': 'Visualizar Motorista',
          'ListaVeiculos': 'Veículos',
          'NovoVeiculo': 'Novo Veículo',
          'EditarVeiculo': 'Editar Veículo',
          'VisualizarVeiculo': 'Visualizar Veículo'
        };
        return routeNames[this.$route.name] || 'Painel Inicial';
      },
      userInitials() {
        if (!this.userData.username) return 'FW';
        const names = this.userData.username.trim().split(' ');
        if (names.length >= 2) {
          return (names[0][0] + names[names.length - 1][0]).toUpperCase();
        }
        return this.userData.username.substring(0, 2).toUpperCase();
      }
    },
    async mounted() {
      await this.fetchUserData();
    },
    methods: {
      //
      // Delega para o controle de sessao: limpeza de storage e redirecionamento
      // existiam em tres copias (aqui, no handle401 do http.js e no Menu.vue) e
      // ja tinham divergido entre si.
      //
      logout() {
        encerrarSessao('manual');
      },
      confirmLogout() {
        this.showLogoutDialog = false;
        this.logout();
      },
      async fetchUserData() {
        try {
          const token = localStorage.getItem('token');
          if (!token) return;

          const response = await axios.get('https://api.portal.workinnovation.com.br/user', {
            headers: {
              'accept': 'application/json, text/plain, */*',
              'authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });

          if (response.data) {
            this.userData = {
              id: response.data.id,
              description: response.data.description,
              username: response.data.username
            };
            localStorage.setItem('userData', JSON.stringify(this.userData));
          }
        } catch (error) {
          const cachedData = localStorage.getItem('userData');
          if (cachedData) {
            this.userData = JSON.parse(cachedData);
          }
        }
      }
    },
  };
  </script>
  
  <style scoped>
  .rounded-0 {
    border-radius: 0;
    color: red;
    font-size: 30px;
  }
  #nav {
    background-color: #ffffff;
    color: #1d4ed8;
  }
  </style>
  